import React, { useEffect, useRef } from 'react';

const PracticeBeamQuestion = ({ allMessages }) => {
    const messagesEndRef = useRef(null);
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }, [allMessages]);

    return allMessages.length > 0 ? (
        <div className="sidebar-container-question" style={{ height: '89%' }}>
            <div
                className="question-timer-container"
                style={{
                    height: '70vh',
                    overflowY: 'auto',
                    padding: '10px',
                    position: 'relative',
                }}
            >
                {(() => {
                    const groupedMessages = [];
                    const filteredMessages = allMessages.filter(
                        (message) =>
                            message && ['Agent', 'You'].includes(message.name) && typeof message.message === 'string'
                    );
                    for (let i = 0; i < filteredMessages.length; i++) {
                        const current = filteredMessages[i];
                        const last = groupedMessages[groupedMessages.length - 1];
                        if (last && last.name === current.name) {
                            last.message += ' ' + current.message;
                        } else {
                            groupedMessages.push({ ...current });
                        }
                    }
                    return groupedMessages.map((msg, index) => (
                        <div key={index} style={{ padding: '5px 0' }}>
                            <b>{msg.name === 'You' ? 'You: ' : 'Interviewer: '}</b>
                            {msg.message}
                        </div>
                    ));
                })()}
                <div ref={messagesEndRef} />
            </div>
        </div>
    ) : (
        <div className="sidebar-container-question" style={{ height: '89%' }}>
            <div className="question-timer-container">
                <p>Connecting...</p>
            </div>
        </div>
    );
};

export default PracticeBeamQuestion;
